import type { Context } from "common/types/context";
import type { WorkOrderVoidedAndArchivedEvent } from "common/types/events";
import type { Entity } from "common/entities/types";
import { ReasonDetails } from "./reason";
import { PropertiesPayload } from "./payload/properties";
import { EmptyDetails } from "./empty";

interface PropTypes {
  event: WorkOrderVoidedAndArchivedEvent;
  context: Context;
  entity: Entity;
  hideLinks?: boolean;
}

export const WorkOrderVoidedAndArchived = ({
  event,
  context,
  entity,
  hideLinks,
}: PropTypes) => {
  return (
    <>
      <legend>{_("Details")}</legend>
      <EmptyDetails event={event} uiFormat={context.uiFormat} />
      <PropertiesPayload
        context={context}
        entity={entity}
        showEmpty={true}
        title={_("Updated record fields")}
        properties={event?.details?.newProperties}
        hideLinks={hideLinks}
      />
      <hr />
      <PropertiesPayload
        context={context}
        entity={entity}
        showEmpty={true}
        title={_("Previous record fields")}
        properties={event?.details?.oldProperties}
        hideLinks={hideLinks}
      />

      <ReasonDetails
        reason={event.details.reason}
        context={context}
        hideLinks={hideLinks}
      />
    </>
  );
};

WorkOrderVoidedAndArchived.displayName = "WorkOrderVoidedAndArchived";
